import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

export default {
  key: 'root',
  storage: storage,
  whitelist: ['estateOverviewFilters'],
  stateReconciler: autoMergeLevel2,
}
